//CSS
import "./app.scss";

//JS
// window.$ = window.jQuery = jQuery;
// import Bootstrap from "bootstrap"; window.bootstrap = Bootstrap;

import "./track";
import "./components/organisms/_master/analytics/analytics.js";

import Player from "@vimeo/player";
import { Popover, Tooltip, Modal, Tab } from "bootstrap";
window.Popover = Popover;
window.Modal = Modal;
window.Tab = Tab;
import AOS from "aos";
window.Aos = AOS;

import Flickity from "flickity";

import "flickity-fade";
import "flickity-hash";

window.Flickity = Flickity;

import panzoom from "panzoom";
window.panzoom = panzoom;

import "masonry-layout";

// components

//Atoms
import "./components/atom/tab-generator/tab-generator.js";
import "./components/atom/list-generator/list-generator.js";
import "./components/atom/modal-generator/modal-generator.js";
import "./components/atom/video-generator/video-generator.js";

//Molecules
import "./components/molecules/square-card/square-card.js";
import "./components/molecules/story-card/story-card.js";
import "./components/molecules/form-newsletter/form-newsletter.js";
// import "./components/molecules/form-newsletter/form-newsletter-api.js"
import "./components/molecules/dealer-locator/dealer-locator.js";
import "./components/molecules/hero-slider/hero-slider.js";
import "./components/molecules/product-card/product-card.js";
import "./components/molecules/parallax-slider/parallax-slider.js";
import "./components/molecules/media-reviews/media-reviews.js";
import "./components/molecules/hero-banner/hero-banner.js";

//Organisms
import "./components/organisms/_master/navigation/navigation.js";
import "./components/organisms/faq-search/faq-search.js";
import "./components/molecules/hero-slider/hero-slider.js";
import "./components/organisms/content/content.js";
import "./components/organisms/tab/tab.js";
import "./components/organisms/card-container/card-container.js";
import "./components/organisms/e-tube/e-tube-features.js";
import "./components/organisms/gear-detail/gear-detail-hero.js";
import "./components/organisms/gear-detail/gear-detail-additional-features.js";
import "./components/organisms/gear-detail/gear-detail-hotspots.js";
import "./components/organisms/bike-detail/bike-detail.js";
import "./components/organisms/_master/navigation/navigation.js";
import "./components/organisms/stories-detail/stories-detail-slider.js";

AOS.init();

var popoverTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="popover"]')
);
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new Popover(popoverTriggerEl);
});

var tooltipTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="tooltip"]')
);
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new Tooltip(tooltipTriggerEl);
});
